import ChartMenuSection from './ChartMenuSection'

export default ChartMenuSection
